import { RNG } from "rot-js";
import { Bounds } from "../../../engine/space/bounds";
import EntityManager from "../../EntityManager";
import { ItemTypes } from "../../items/itemsTypes";
import { GraphNode } from "../graph/buildMinSpanTree";
import { ShrineMap } from "../ShrineMap";
import { getRandomInBounds } from "./placement";

export const placeShrines = (
  rng: typeof RNG,
  map: ShrineMap,
  graph: Map<number, GraphNode>
) => {
  let bestStart: Bounds | null = null;
  let bestEnd: Bounds | null = null;
  let room: GraphNode;

  while (!bestStart || !bestEnd) {
    const leftY = rng.getUniformInt(5, map.height - 5);
    const rightY =
      leftY < map.height / 2
        ? rng.getUniformInt(Math.floor(map.height / 2), map.height - 5)
        : rng.getUniformInt(5, Math.floor(map.height / 2));

    for (room of graph.values()) {
      if (room.bounds.y <= leftY && leftY <= room.bounds.y + room.bounds.h) {
        if (!bestStart || room.bounds.x <= bestStart.x) {
          bestStart = room.bounds;
        }
      }

      if (room.bounds.y <= rightY && rightY <= room.bounds.y + room.bounds.h) {
        if (!bestEnd || bestEnd.x <= room.bounds.x) {
          bestEnd = room.bounds;
        }
      }
    }
  }
  const one = getRandomInBounds(rng, bestStart);
  const two = getRandomInBounds(rng, bestEnd);
  if (rng.getUniformInt(0, 1)) {
    EntityManager.createItem(ItemTypes.oldFont, one.x, one.y);
    EntityManager.createItem(ItemTypes.newFont, two.x, two.y);
    return [one, bestStart] as const;
  } else {
    EntityManager.createItem(ItemTypes.newFont, one.x, one.y);
    EntityManager.createItem(ItemTypes.oldFont, two.x, two.y);
    return [two, bestEnd] as const;
  }
};
